"use client";
import Image from "next/image";
import { Heading } from "@/components/ui/typography";
import Link from "next/link";

export default function ComplianceCTASection({ heading = "Your Home Country Still Matters, and We Plan Around It" }: { heading?: string } = {}) {
  return (
    <section className="w-full flex justify-center md:py-[60px] py-[30px] px-4 min-[1340px]:px-0">
      <div className="w-full max-w-[1200px] flex flex-col lg:flex-row gap-10 lg:gap-[32px] items-center">
        {/* LEFT CONTENT */}
        <div className="flex-1 flex flex-col gap-8">
          {/* HEADING */}
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[15px] sm:text-[16px] leading-[24px] font-medium">
              A responsible tax strategy always considers your personal tax
              residency. This structure works best when:
            </p>
          </div>

          {/* CHECKLIST */}
          <div className="flex flex-col gap-4">
            {[
              "You operate internationally",
              "Your customers are outside your home country",
              "Your management decisions occur outside high-tax jurisdictions",
              "Your structure supports non-domicile positioning",
            ].map((item, i) => (
              <div key={i} className="flex gap-3 items-start">
                <div className="pt-[4px]">
                  <Image
                    src={`/list-check.svg`}
                    alt="tick"
                    width={19}
                    height={19}
                  />
                </div>
                <p className="text-white/70 text-[16px] leading-[150%] flex-1">
                  {item}
                </p>
              </div>
            ))}
          </div>

          {/* IMPORTANT BOX */}
          <div className="bg-[#0f1218] border border-white/10 rounded-[12px] p-6 shadow-md">
            <p className="text-[14px] leading-[150%]">
              <span className="font-semibold text-white">
                Important:&nbsp;
              </span>
              <span className="text-white/70 font-medium">
                <Link className="hover:underline" href="/">
                  MuteTaxes
                </Link>{" "}
                does not assist with tax evasion. Everything we build is
                designed for compliance with Hong Kong law and awareness of your
                home country obligations. This is why the strategy call happens
                before incorporation begins.
              </span>
            </p>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="flex-1 flex justify-center items-center h-full">
          <Image
            src="/tax-optimization/compliance-cta.webp"
            alt="Compliance"
            width={700}
            height={700}
            className="w-full h-[420px] sm:h-[580px] lg:h-[634px] object-cover rounded-[16px]"
          />
        </div>
      </div>
    </section>
  );
}
